import { Link, LinksSection } from "@components/common/LinksSection";
import {
  DurationEnum,
  SupplierFiltersResponse,
  TourFiltersResponse,
} from "@graphql/types";
import { SearchType, searchURL } from "@helpers/searchURL";
import { t } from "@helpers/translate";
import { ParsedUrlQuery } from "querystring";

const durationLinks = {
  [DurationEnum.LessThreeHours]: {
    key: "less-3-hours",
    label: t({
      id: "search.filters.duration.less-3-hours",
      message: "Less than 3 hours",
    }),
  },
  [DurationEnum.FullDay]: {
    key: "full-day",
    label: t({
      id: "search.filters.duration.full-day",
      message: "Full Day (more than 5 hours)",
    }),
  },
  [DurationEnum.HalfDay]: {
    key: "half-day",
    label: t({
      id: "search.filters.duration.half-day",
      message: "Half Day (up to 5 hours)",
    }),
  },
  [DurationEnum.MultipleDays]: {
    key: "multiple-days",
    label: t({
      id: "search.filters.duration.multiple-days",
      message: "Multiple Days",
    }),
  },
};

interface Props {
  filters: TourFiltersResponse | SupplierFiltersResponse;
  query: ParsedUrlQuery;
}

export const getFiltersLinksSections = ({ filters, query }: Props) => {
  const sections: LinksSection[] = [];

  if (filters?.categories?.length) {
    const links: Link[] = [];
    filters.categories.forEach((category) => {
      links.push({
        title: `${category.name}`,
        url: searchURL({
          category: category.slug,
          country: query.country as string,
          city: query.city as string,
          t: query.t as SearchType,
        }),
      });
    });

    sections.push({
      title: "Categories",
      links,
    });
  }

  if (filters?.durations?.length) {
    const links: Link[] = [];
    filters.durations.forEach((duration) => {
      links.push({
        title: durationLinks[duration].label,
        url: searchURL({
          duration: durationLinks[duration].key,
          country: query.country as string,
          city: query.city as string,
          t: query.t as SearchType,
        }),
      });
    });

    sections.push({
      title: "Duration",
      links,
    });
  }

  if (filters?.languages?.length) {
    const links: Link[] = [];
    filters.languages.forEach((language) => {
      links.push({
        title: `${language.name}`,
        url: searchURL({
          language: language.code,
          country: query.country as string,
          city: query.city as string,
          t: query.t as SearchType,
        }),
      });
    });

    sections.push({
      title: "Languages",
      links,
    });
  }

  return sections;
};
